import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-slate-900/95 sticky top-0 z-50 backdrop-blur-sm border-b border-slate-800">
      <div className="container py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img 
                src="/assets/Legendary Brushstrokes Logo.png" 
                alt="Legendary Brushstrokes" 
                className="h-8 md:h-10" 
              />
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex md:items-center md:space-x-6">
            <a href="#features" className="text-white hover:text-purple-400 transition">
              Features
            </a>
            <a href="#about" className="text-white hover:text-purple-400 transition">
              About
            </a>
            <Link 
              to="/kickstarter" 
              className="btn-primary"
            >
              Join Kickstarter
            </Link>
          </div>
          
          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-purple-400 focus:outline-none"
              onClick={() => setIsOpen(!isOpen)}
            >
              <span className="sr-only">Open main menu</span>
              {isOpen ? (
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <motion.div 
          className="md:hidden bg-slate-800 shadow-lg"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3 }}
        >
          <div className="px-3 pt-2 pb-4 space-y-3">
            <a 
              href="#features" 
              className="block px-3 py-2 text-white hover:text-purple-400 transition"
              onClick={() => setIsOpen(false)}
            >
              Features
            </a>
            <a 
              href="#about" 
              className="block px-3 py-2 text-white hover:text-purple-400 transition"
              onClick={() => setIsOpen(false)}
            >
              About
            </a>
            <Link 
              to="/kickstarter" 
              className="block px-3 py-2 mt-4 text-center btn-primary"
              onClick={() => setIsOpen(false)}
            >
              Join Kickstarter
            </Link>
          </div>
        </motion.div>
      )}
    </nav>
  );
};

export default Navbar;